export const environment = {
  production: false,
  urlServer: "https://iguau.devwebsite.es/",
  urlWeb: "https://iguau.devwebsite.es/",
  urlBase: "",
  recaptcha: {
    siteKey: '6LcgzbAqAAAAAA7xcwrP6IPhxCnNGMfgjlBFK_bv'
  },
  nombre: 'staging',
};
